export const SEND_DOCUMENTS = 'SEND_DOCUMENTS';
export const EMAIL_CONTACTS = 'EMAIL_CONTACTS';

export const emailContexts = {
  NOT_TRACKING_ACTION: 'NOT_TRACKING_ACTION',
  SHIPMENT_DETAILS: 'SHIPMENT_DETAILS'
};
